import React from 'react'
import styled, { css } from 'styled-components';

import heroImage from '../../images/chicago.jpeg';
import researchImage from '../../images/sea.jpeg';
import teachingImage from '../../images/forest.jpeg';
import peopleImage from '../../images/ocean.jpeg';

const Container = styled.div`
  display: ${props =>
    (props.page && 'inline-block')
    || 'flex'
  };
  flex-direction: column;
  justify-content: center;
  padding: 40px 10px;
  min-height: ${props =>
    (props.page && '100vh')
    || (props.small && '0vh')
    || (props.hero && '95vh')
    || '500px'
  };
  font-family: Lato, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;
  ${'' /* height: ${props =>
  (props.hero && '95vh')
  }; */}
  width: ${props =>
    (props.page && '100%')
  };
  background: ${props =>
    (props.purple && 'mediumpurple')
    || (props.grey && '#eee')
    || (props.blue && 'steelblue')
    || (props.green && 'seagreen')
    || (props.teal && 'lightseagreen')
    || (props.hero && `linear-gradient(rgba(102, 51, 153, 0.6),rgba(70, 130, 180,0.7)),url(${heroImage});`)
    || (props.research && `linear-gradient(rgba(70, 130, 180,0.8),rgba(70, 130, 180,0.9)),url(${researchImage});`)
    || (props.teaching && `linear-gradient(rgba(46, 139, 87, 0.7),rgba(46, 139, 87, 0.8)),url(${teachingImage});`)
    || (props.people && `linear-gradient(rgba(102, 51, 153, 0.7),rgba(147, 112, 219, 0.8)),url(${peopleImage});`)
  };

  background-size: ${props =>
    ((props.hero || props.research || props.teaching || props.people) && 'cover')
  };
  background-position: ${props =>
    ((props.hero || props.research || props.teaching || props.people) && 'center')
  };
  background-repeat: ${props =>
    ((props.hero || props.research || props.teaching || props.people) && 'no-repeat')
  };

  @media (max-width: 600px) {
    min-height: ${props =>
      (props.hero && '50vh')
    };
  }
`;

export default Container;



// WEBPACK FOOTER //
// ./src/components/Shared/Container.js